import React from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "rhombus-react";

import Permissioned from "widgets/Permissioned";
import AgentNavItem from "widgets/header/AgentNavItem";

const HELP = {
	id:"help",
	icon:"fas fa-question-circle",
	title:"View Help",
	className:"ft-help-item pendo-help-nav-icon",
};

const CREATIVE_LIBRARIES = {
	id:"creativeLibraries",
	icon:"fas fa-folders",
	label:"Creative Libraries",
	title:"Creative Libraries",
	link:"/libraries/",
	className:"",
	/**
	 * rhombus-react is using react-router version 4.x
	 * 		We can't really upgrade rhombus just yet because other things are relying on it
	 * 		However, it seems that the main area that can cause problems
	 * 		If we provide a `renderChild` function, then we short-circuit the rhombus stuff
	 */
	renderChild:(props, classes) => {
		return (
			<NavLink to={props.link} className={classes} title={props.title}>
				<Icon name={props.icon} />
				<span className="ft-nav-label">Creative Libraries</span>
			</NavLink>
		);
	},
};

const QA_PANEL = {
	id:"qaPanel",
	icon:"fas fa-badge-check",
	label:"QA Panel",
	title:"QA Panel",
	link:"/qa-panel/",
	className:"",
	renderChild:(props, classes) => {
		return (
			<Permissioned domain="Creative View" action="Studio Panel">
				<NavLink to={props.link} className={classes} title={props.title}>
					<Icon name={props.icon} />
					<span className="ft-nav-label">QA Panel</span>
				</NavLink>
			</Permissioned>
		);
	},
};

// Core Agent nav item, see CoreAgentBlade.js
const CORE_AGENT = {
	id:"coreAgent",
	className:"",
	renderChild:(props, classes) => <AgentNavItem classes={classes} />,
};

const NAV_ITEMS = [
	CREATIVE_LIBRARIES,
	QA_PANEL,
	CORE_AGENT,
	HELP,
];

export default NAV_ITEMS;
